import { useRef } from "react";

import styled from "styled-components";

import { FiltersAndActionItems } from "../chartFiltersAndLegends/FiltersAndActionItems";

import { HighLevelMetricsSingularChart } from "./HighLevelMetricsSingularChart";
import { PngHeader } from "./PngHeader";

const ChartWrapperContainer = styled.div`
    padding: 20px;
`;

export const HighLevelMetricsSingularChartWrapper = () => {
    const chartRef = useRef<HTMLDivElement>(undefined);
    return (
        <ChartWrapperContainer ref={chartRef}>
            <PngHeader />
            <FiltersAndActionItems chartRef={chartRef} />
            <HighLevelMetricsSingularChart />
        </ChartWrapperContainer>
    );
};
